// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2V1DP","header":"MessagesList_header__1cibn","chat":"MessagesList_chat__2uJGq"};